module.exports = __webpack_public_path__ + "static/img/chrome.a4fa458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/browsers/chrome.png
// module id = iB4l
// module chunks = 0